import { render, staticRenderFns } from "./Wirksamkeitspruefung.vue?vue&type=template&id=d4c8f80c&scoped=true"
import script from "./Wirksamkeitspruefung.vue?vue&type=script&lang=js"
export * from "./Wirksamkeitspruefung.vue?vue&type=script&lang=js"
import style0 from "./Wirksamkeitspruefung.vue?vue&type=style&index=0&id=d4c8f80c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c8f80c",
  null
  
)

export default component.exports